import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/modules/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    // const _authService = inject(AuthService);
    const tokenData = sessionStorage.getItem('access_token');
    // Check the authentication status
    try {
        const token = JSON.parse(tokenData || '{}')?.accessToken;
        if (token) {
            return of(router.parseUrl(''));
        } else {
            return true;
        }
        // if (_authService._authenticated) {
        //      return of(router.parseUrl(''));
        //    }
    } catch (e) {
        console.error('AuthGuard error parsing token:', e);
        return true;
    }
};
